export interface CollapseInterface {
  expanded: boolean;
  toggle(): void;
}

const Collapse = (initial: boolean = false): CollapseInterface => ({
  expanded: initial,

  toggle(): void {
    this.expanded = !this.expanded;
  },
});

export default Collapse;
